module.exports = __webpack_public_path__ + "img/doja.812d81bd.jpg";